module.exports = "\n\n    <ul class=\"location-selections\">\n        <li ng-repeat=\"userLocation in main.userLocations\" ng-class=\"{'active': main.currentLocation.ContractorId === userLocation.ContractorId}\"\n            ng-click=\"main.updateLocation($event,userLocation); topNav.isCollapsed = true; topNav.isPopoverOpen = false\">\n            <span>{{userLocation.LocationNickname}}</span>\n        </li>\n    </ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/topNav/popovers/locationSwitcher.html
// module id = 952
// module chunks = 1